// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".file-ctn {\n  display: flex;\n  width: 100%;\n  height: 100%;\n}\n.file-ctn .json {\n  width: 50%;\n  height: 50%;\n  margin: auto;\n  transform: translateY(0);\n  background-color: var(--inspectorTargetColor);\n}\n", ""]);
// Exports
module.exports = exports;
